import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import Multiselect from 'vue-multiselect'
import {
  BTooltip,
  BButton,
  BCard,
  BTable,
  BCollapse,
  BFormGroup,
  BFormInput,
  BModal,
  VBToggle,
  VBModal
} from 'bootstrap-vue'

export default {
  name: 'Admin',
  components: {
    Loading,
    Multiselect,
    BTooltip,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
    BFormInput,
    BModal
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal
  },
  mixins: [mixins],
  data() {
    return {
      url: 'admin/admin',
      widgets: [
        'roles',
        'sell_types'
      ],
      fields: [
        { key: 'id', label: 'شناسه' },
        { key: 'name', label: 'نام' },
        { key: 'username', label: 'نام کاربری' },
        { key: 'email', label: 'ایمیل' },
        { key: 'mobile', label: 'شماره تماس' },
        { key: 'created_at', label: 'تاریخ ثبت' },
        { key: 'edit', label: 'ویرایش' },
        { key: 'delete', label: 'حذف' }
      ],
      filter: {
        name: '',
        username: ''
      },
      form: {
        name: '',
        username: '',
        email: '',
        mobile: '',
        password: '',
        role: null,        // object { id, label }
        sell_type: null,   // object { id, label }
        pos: []            // array of objects { id, label }
      },
      posList: [],
      mode: 'create',
      edit: null
    }
  },
  computed: {
    roleOptions() {
      const list = (this.widgetData && (this.widgetData.roles || [])) || []
      return list.map(r => ({
        id: r.id,
        label: r.label || r.name || `Role #${r.id}`
      }))
    },
    sellTypeOptions() {
      const list =
        (this.widgetData &&
          (this.widgetData.sell_types || this.widgetData.sellTypes || [])) ||
        []
      return list.map(s => ({
        id: s.id,
        label: s.label || s.title || `SellType #${s.id}`
      }))
    },
    posOptions() {
      return (this.posList || []).map(p => ({
        id: p.id,
        label: p.name || p.title || p.label || `POS #${p.id}`
      }))
    },
    modalTitle() {
      return this.mode === 'create' ? 'مدیر جدید' : 'ویرایش مدیر'
    }
  },
  mounted() {
    this.loadItems()
    this.loadPosList()
  },
  methods: {
    async loadPosList() {
      try {
        const response = await this.$axios.get('admin/pos', {
          params: { show_all: 1 }
        })
        this.posList =
          response.data.data.poses ||
          []
      } catch (error) {
        console.error('خطا در دریافت لیست POS:', error)
        this.posList = []
      }
    },

    resetForm() {
      this.form = {
        name: '',
        username: '',
        email: '',
        mobile: '',
        password: '',
        role: null,
        sell_type: null,
        pos: []
      }
    },

    setFormFromItem(item) {
      if (!item) {
        this.resetForm()
        return
      }

      // پیدا کردن نقش
      let roleObj = null
      let roleId = null
      if (item.role !== undefined && item.role !== null) {
        roleId = typeof item.role === 'object' ? item.role.id : item.role
      } else if (item.role_id !== undefined) {
        roleId = item.role_id
      }
      if (roleId !== null) {
        roleObj = this.roleOptions.find(r => r.id == roleId) || { id: roleId, label: `Role #${roleId}` }
      }

      // پیدا کردن نوع فروش
      let sellTypeObj = null
      const sellTypeId = item.sell_type_id || (item.sell_type && item.sell_type.id) || null
      if (sellTypeId !== null) {
        sellTypeObj = this.sellTypeOptions.find(s => s.id == sellTypeId) || { id: sellTypeId, label: `SellType #${sellTypeId}` }
      }

      // پیدا کردن POSها
      let posObjs = []
      let posIds = []
      if (Array.isArray(item.pos)) {
        posIds = item.pos.map(p => (typeof p === 'object' ? p.id : p))
      } else if (Array.isArray(item.poses)) {
        posIds = item.poses.map(p => (typeof p === 'object' ? p.id : p))
      }
      posObjs = posIds.map(id => {
        return this.posOptions.find(p => p.id == id) || { id, label: `POS #${id}` }
      })

      this.form = {
        name: item.name || '',
        username: item.username || '',
        email: item.email || '',
        mobile: item.mobile || '',
        password: '',
        role: roleObj,
        sell_type: sellTypeObj,
        pos: posObjs
      }
    },

    createItem() {
      this.mode = 'create'
      this.edit = null
      this.resetForm()
      // مودال با v-b-modal.admin باز می‌شود، اما برای اطمینان:
      this.$nextTick(() => {
        if (this.$refs.adminModal) {
          this.$refs.adminModal.show()
        }
      })
    },

    editItem(index) {
      this.mode = 'edit'
      const item = this.items.data[index]
      this.edit = item
      this.setFormFromItem(item)
      this.$nextTick(() => {
        if (this.$refs.adminModal) {
          this.$refs.adminModal.show()
        }
      })
    },

    async filterItem(page = 1) {
      this.searchParams = {
        search1: this.filter.name,
        searchBy1: 'name',
        search2: this.filter.username,
        searchBy2: 'username'
      }
      if (typeof this.loadItems === 'function') {
        await this.loadItems(page)
      }
    },

    onModalOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.submitForm()
    },

    async submitForm() {
      if (!this.form.username || this.form.username.length < 2) {
        this.$bvToast.toast('نام کاربری الزامی است و باید حداقل ۲ کاراکتر باشد', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (this.mode === 'create') {
        if (!this.form.password || this.form.password.length < 6) {
          this.$bvToast.toast('رمز عبور الزامی است و باید حداقل ۶ کاراکتر باشد', {
            title: 'خطا',
            variant: 'danger',
            solid: true
          })
          return
        }
      }

      if (!this.form.role) {
        this.$bvToast.toast('انتخاب نقش الزامی است', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        })
        return
      }

      if (!this.form.sell_type) {
        this.$bvToast.toast('انتخاب نوع فروش الزامی است', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        })
        return
      }

      // ساخت payload با idها
      const payload = {
        name: this.form.name,
        username: this.form.username,
        email: this.form.email || null,
        mobile: this.form.mobile || null,
        role: this.form.role.id,
        sell_type_id: this.form.sell_type.id,
        pos: Array.isArray(this.form.pos) ? this.form.pos.map(p => Number(p.id)) : []
      }

      if (this.mode === 'create' || (this.form.password && this.form.password.length >= 6)) {
        payload.password = this.form.password
      }

      try {
        this.disabled = true

        if (this.mode === 'create') {
          await this.$axios.post(this.url, payload)
        } else {
          const id = this.edit && this.edit.id
          if (!id) {
            throw new Error('شناسه آیتم برای ویرایش پیدا نشد')
          }
          await this.$axios.put(`${this.url}/${id}`, payload)
        }

        // موفقیت
        if (this.$bvToast) {
          this.$bvToast.toast(this.mode === 'create' ? 'مدیر با موفقیت ثبت شد' : 'مدیر با موفقیت ویرایش شد', {
            title: 'موفق',
            variant: 'success',
            solid: true
          })
        }

        if (this.$refs.adminModal) {
          this.$refs.adminModal.hide()
        }

        // رفرش لیست
        if (typeof this.loadItems === 'function') {
          await this.loadItems()
        }
      } catch (error) {
        console.error(error)
        // اگر بک‌اند پیام خطا فرستاده
        const message =
          (error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
          'خطایی رخ داد'
        if (this.$bvToast) {
          this.$bvToast.toast(message, {
            title: 'خطا',
            variant: 'danger',
            solid: true
          })
        }
      } finally {
        this.disabled = false
      }
    }
  }
}

